import Button from "@booking/components/atoms/forms/Button";

import { ColorEnum } from "@/enums";

import { PHONE_LINK, PHONE_NUMBER_DISPLAY } from "../utils/constants";
import styles from "./CreateYourOwnResult.module.css";

interface CreateYourOwnErrorViewProps {
  onRetry: () => void;
}

function CreateYourOwnErrorView(props: CreateYourOwnErrorViewProps) {
  const { onRetry } = props;

  return (
    <div className={styles.wrapper} data-component="error">
      <section>
        <h2 className={styles.title}>Oops, something went wrong</h2>
        <p>
          We're sorry, but there was an error submitting your enquiry. Please
          try again or call us on{" "}
          <a href={PHONE_LINK}>{PHONE_NUMBER_DISPLAY}</a> to speak with one of
          our golf specialists.
        </p>

        <Button color={ColorEnum.GREEN} onClick={onRetry}>
          Try Again
        </Button>
      </section>
    </div>
  );
}

export default CreateYourOwnErrorView;
export { CreateYourOwnErrorView, type CreateYourOwnErrorViewProps };
